import { render, staticRenderFns } from "./Airwallex.vue?vue&type=template&id=95a64e74"
import script from "./Airwallex.vue?vue&type=script&lang=js"
export * from "./Airwallex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports